import { all, takeLatest } from 'redux-saga/effects'

import { SocketActions } from '../actions'
import { close } from './close'
import { emit } from './emit'
import { init } from './init'
import { subscribe } from './subscribe'
import { unsubscribe } from './unsubscribe'
import { updateProject } from './updateProject'

export function* socketSaga() {
  yield all([
    takeLatest(SocketActions.init, init),
    takeLatest(SocketActions.close, close),
    takeLatest(SocketActions.subscribe, subscribe),
    takeLatest(SocketActions.unsubscribe, unsubscribe),
    takeLatest(SocketActions.emit, emit),
    takeLatest(SocketActions.updateProject, updateProject),
  ])
}
